import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

import Frame1 from "../../../assets/images/public-pages/Frame1.svg";
import Frame2 from "../../../assets/images/public-pages/Frame2.svg";
import Frame3 from "../../../assets/images/public-pages/Frame3.svg";
import Frame4 from "../../../assets/images/public-pages/Frame4.svg";
import Frame5 from "../../../assets/images/public-pages/Frame5.svg";
import Frame6 from "../../../assets/images/public-pages/Frame6.svg";
import Frame7 from "../../../assets/images/public-pages/Frame7.svg";
import Frame8 from "../../../assets/images/public-pages/Frame8.svg";
import Frame9 from "../../../assets/images/public-pages/Frame9.svg";
import Frame10 from "../../../assets/images/public-pages/Frame10.svg";
import Frame11 from "../../../assets/images/public-pages/Frame11.svg";
import Frame12 from "../../../assets/images/public-pages/Frame12.svg";
import Frame13 from "../../../assets/images/public-pages/Frame13.svg";
import Frame14 from "../../../assets/images/public-pages/Frame14.svg";
import Frame15 from "../../../assets/images/public-pages/Frame15.svg";
import Frame16 from "../../../assets/images/public-pages/Frame16.svg";
import Frame17 from "../../../assets/images/public-pages/Frame17.svg";
import Frame18 from "../../../assets/images/public-pages/Frame18.svg";
import Frame19 from "../../../assets/images/public-pages/Frame19.svg";
import Speaking from "../../../assets/images/public-pages/speaking-mastery.png";
import Writing from "../../../assets/images/public-pages/90-listening.png";
import Reading from "../../../assets/images/public-pages/reading-techniques.png";
import Listening from "../../../assets/images/public-pages/accuracy-drills.png";
import ProvenResult from "../../../assets/images/public-pages/proven-result.svg";
import ExpertFaculty from "../../../assets/images/public-pages/expert-faculty.svg";
import Learning from "../../../assets/images/public-pages/learning.svg";
import Screening from "../../../assets/images/public-pages/Screening.svg";
import IconCall from "../../../assets/images/public-pages/blue-call.svg";
import IconEmail from "../../../assets/images/public-pages/blue-email.svg";
import IconChats from "../../../assets/images/public-pages/blue-chats.svg";
import IconLocation from "../../../assets/images/public-pages/blue-location.svg";
import IconClock from "../../../assets/images/public-pages/blue-clock.svg";
import IconInfo from "../../../assets/images/public-pages/blue-info.svg";

import "../../../assets/css/pte-responsive.css";
import Immigration from "../../../assets/images/public-pages/victoria-take-test.png";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import TestSection from "components/PublicPagesReusable/TestSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import Footer from "../Footer";
import Header from "../Header";
import ReusableHomePageSlider from "page/ReusableHomePageSlider";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import PteConsultation from "components/PublicPagesReusable/PteConsultation";
import CTAContactSection from "components/PublicPagesReusable/CTAContactSection";
import CourseCard from "components/PublicPagesReusable/CourseCard";
import Document from "../../../assets/images/public-pages/grey-doc.svg";
import GreenDocument from "../../../assets/images/public-pages/green-doc.svg";
import TickCircle from "../../../assets/images/public-pages/green-tick-circle.png"
import Profile from "../../../assets/images/public-pages/grey-profile.svg";

const images = [
  { src: Frame1, alt: "score-1" },
  { src: Frame2, alt: "score-2" },
  { src: Frame3, alt: "score-3" },
  { src: Frame4, alt: "score-4" },
  { src: Frame5, alt: "score-5" },
  { src: Frame6, alt: "score-6" },
  { src: Frame7, alt: "score-7" },
  { src: Frame8, alt: "score-8" },
  { src: Frame9, alt: "score-9" },
  { src: Frame10, alt: "score-10" },
  { src: Frame11, alt: "score-11" },
  { src: Frame12, alt: "score-12" },
  { src: Frame13, alt: "score-13" },
  { src: Frame14, alt: "score-14" },
  { src: Frame15, alt: "score-15" },
  { src: Frame16, alt: "score-16" },
  { src: Frame17, alt: "score-17" },
  { src: Frame18, alt: "score-18" },
  { src: Frame19, alt: "score-19" },
];

const heroDescriptionSection = () => (
  <p className="sub-title text-center FS16FW500">
    From Brisbane's academic hubs to professionals in Gold Coast, Sunshine Coast, Cairns
    <br /> & regional Queensland, our PTE Online Coaching in Queensland delivers expert-led virtual training aligned with the latest exam patterns.
  </p>
);

const contentSection = () => (
  <h3 className="top-section-text FS40FW600">
    Elevate Your PTE Performance with<br />
    <span className="text-success FS40FW600">Premier Online Coaching in Queensland</span>
  </h3>
);

const skillAreaTitle = () => (
  <h3 className="top-section-text mb-4 white FS40FW600">
    Learn With <span className="text-success FS40FW600">Language Academy <br /></span> -
    Watch Our Tutorials
  </h3>
);

const lifestyleCards = [
  {
    title: "Speaking Mastery ",
    color: "transparent",
    img: Speaking,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "3rRY96mbizY",
  },
  {
    title: "PTE 90/90 Method",
    color: "transparent",
    img: Writing,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "t4oyY3EPYGQ",
  },
  {
    title: "Secret Scoring Guide",
    color: "transparent",
    img: Reading,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "IPy4d8zzV2U",
  },
  {
    title: "Writing Mistakes and their Fix",
    color: "transparent",
    img: Listening,
    width: "100%",
    height: "100%",
    transform: " rotate(-5deg)",
    videoUrl: "U8yBis5fGn0",
  },
];

const skillAreaTitle2 = () => (
  <h3 className="top-section-text FS40FW600">
    Why We're Recognised Among<br />
    <span className="text-success FS40FW600">Queensland's Leading PTE Online Institutes</span><br />
  </h3>
);

const skillAreaTitle3 = () => (
  <h3 className="top-section-text FS40FW600">
    Comprehensive PTE Online Course Features -<span className="text-success FS40FW600">Designed for Queensland Students</span><br />
  </h3>
);

const skillAreaTitle4 = () => (
  <h3 className="top-section-text FS40FW600">
    Strategic Score Targets:<br />
    <span className="text-success FS40FW600">Tailored Pathways for Queensland Students</span>
  </h3>
);

const styleCards = [
  {
    title: "Proven Track Record",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li><span className="fw-800">50,000+</span> successful students across Australia</li>
        <li>Average score improvement of <span className="fw-800">20+ points</span></li>
        <li>Specialised coaching for <span className="fw-800">50+, 65+, 79+</span> score targets</li>
      </ul>
    ),
    color: "#141414",
    img: ProvenResult,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Expert Faculty Team",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li>Certified <span className="fw-800">PTE trainers</span> with advanced expertise</li>
        <li>Regular updates aligned with the <span className="fw-800">latest PTE patterns</span></li>
        <li><span className="fw-800">Personal mentoring</span> tailored to individual performance gaps</li>
      </ul>
    ),
    color: "#141414",
    img: ExpertFaculty,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Advanced Online Learning Platform ",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li><span className="fw-800">Live</span> interactive virtual classes</li>
        <li><span className="fw-800">AI-powered practice simulations</span></li>
        <li><span className="fw-800">Recorded sessions</span> for revision</li>
        <li>Flexible batch timings across <span className="fw-800">Queensland</span></li>
      </ul>
    ),
    color: "#141414",
    img: Learning,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Comprehensive Study Resources",
    text: (
      <ul className="feature-list plus-sans FS16FW500 fw-400">
        <li>Updated curriculum aligned with the <span className="fw-800">current PTE format</span></li>
        <li>Extensive question banks with <span className="fw-800">detailed explanations</span></li>
        <li><span className="fw-800">Performance tracking</span> dashboards</li>
      </ul>
    ),
    color: "#141414",
    img: Screening,
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
];

const styleCards2 = [
  {
    title: "Premium Study Materials ",
    greenTitle: "MATERIALS",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Latest PTE templates for all question types</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Online portal access with 1000+ practice questions</li>
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Video lesson library covering scoring strategies</li>
        <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data" />Mobile-friendly access for convenient learning </li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Realistic Mock Tests & Performance Analysis",
    greenTitle: "ANALYTICS",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
        <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Computer-based mock tests simulating real exam conditions</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Detailed score reports with section-wise breakdown</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>AI-driven feedback system</li>
         <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data"/>Weekly performance tracking with actionable insights</li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Expert-Led Interactive Sessions ",
    greenTitle: "SESSIONS",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Small batch sizes for focused learning</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Live doubt-clearing classes</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Targeted improvement plans</li>
         <li className="d-flex align-items-start gap-2 "><img src={TickCircle} alt="Check" className="list-data"/>Guidance beyond language skills, including exam confidence</li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
  {
    title: "Flexible Online PTE Classes QLD",
    greenTitle: "FLEXIBILITY",
    text: (
      <ul className="plus-sans FS16FW500 fw-400 px-0">
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Weekday and weekend batches</li>
         <li className="d-flex align-items-start gap-2 mb-3"><img src={TickCircle} alt="Check" className="list-data"/>Evening sessions for working professionals</li>
         <li className="d-flex align-items-start gap-2"><img src={TickCircle} alt="Check" className="list-data"/>Access from anywhere in Queensland </li>
      </ul>
    ),
    color: "#141414",
     boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
    borderColor:'rgba(0, 0, 0, 0.05)'
  },
];

const testData = {
  title: 'Why Students Across Queensland Trust Our<br/>',
  highlight: "PTE Online Coaching Programs",
  bottomDescription: 'We help students prepare strategically, not randomly. ',
  cta: "Start Your PTE Preparation Today",
  list: [
    "Structured online curriculum aligned with PTE scoring logic",
    "Flexible learning designed for working professionals",
    "AI-based mock tests that simulate real exam experience",
    "Dedicated mentorship for consistent improvement",
    "High success rates across Queensland",
    // "Targeted preparation for 50+, 65+ and 79+ scores",
  ],
};

const sliderList = {
  title: "Success Stories from <span>Queensland Students</span>",
  subtitle: "Students across Brisbane, Gold Coast, and regional QLD have achieved significant improvements through our structured PTE Preparation Online programs.",

  settings: {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0:    { slidesPerView: 1 },
      768:  { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  },

  items: [
    {
      id: 1,
      name: "Amit K.",
      location: "Brisbane, Queensland",
      description:
        "Improved from 57 to 79 in eight weeks through structured mock testing and targeted fluency correction.",
      image:Profile,
    },
    {
      id: 2,
      name: "Lina W.",
      location: "Gold Coast, Queensland",
      description:
        "Achieved 65+ on the first attempt after focused preparation in Repeat Sentence and Write From Dictation",
      image: Profile,
    },
    {
      id: 3,
      name: "Carlos M.",
      location: "Sunshine Coast, Queensland",
      description:
        "Secured the required migration score after previous unsuccessful attempts elsewhere. ",
      image: Profile,
    },
  ],
};

const faqQuestions = [
  {
    question: "How long does PTE preparation take in QLD? ",
    answer:
      "Preparation timelines vary based on current English level and target score. Most Queensland students achieve their required scores within 4 to 12 weeks of consistent structured coaching.",
  },
  {
    question: "Are online PTE classes effective for Queensland students? ",
    answer:
      "Yes. Our PTE Online Classes in QLD deliver the same structured curriculum, interactive sessions, and performance tracking as classroom programs, with added flexibility.",
  },
  {
    question: "What is included in your PTE Online Course in QLD? ",
    answer:
      "Live training sessions, AI mock tests, detailed score reports, study materials, recorded classes, and personalised feedback.",
  },
  {
    question: "Do you offer flexible timings for Queensland students? ",
    answer:
      "Yes. We provide weekday, evening, and weekend batches to suit different schedules across Queensland.",
  },
];

const Queensland = () => {
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const openPopup = () => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("staticBackdrop")
    );
    modal.show();
  };

  const heroWorkTitle = () => (
    <h1 className="FS48 fw-500 top-section-text">
      <span className="text-success fw-600">PTE Online Coaching in Queensland - <br/></span>
      Master English Proficiency with <br/>Expert-Led Virtual Training
    </h1>
  );

  const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: heroWorkTitle,
    subtitle:
      "Professional PTE Academic Coaching across Queensland – Live Online Training for Brisbane, Gold Coast, Sunshine Coast, Cairns & regional QLD.",
    btn_prepration: {
      text: "Book Your Free PTE Assessment",
      onClick: openPopup,
    },
    btn_outline: {
      text: "Demo Class",
      variant: "outline",
      onClick: openPopup,
    },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/User-02.svg",
      "/images/web-new-images/new-content-slider/User-03.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" },
      ],
    },
    bottomStats: [
      { value: "8", highlight: "+", label: "Years of PTE Expertise" },
      { value: "30", highlight: "+", label: "Countries Served" },
      { value: "/5", highlight: "4.8", label: "Rated PTE Practice App" },
      { value: "-Powered", highlight: "AI", label: "Scoring Engine" },
    ],
  };

 const tableData = [
  {
    id: 1,
    img: Document,
    hoverImg: GreenDocument,
    badge: "Beginners",
    title: "Online Foundation",
    text: "Core modules + practice",
    btnText: "Enroll Now",
    width: "28px",
    height: "28px",
    link: "/auth/register",
  },
  {
    id: 2,
    img: Document,
    hoverImg: GreenDocument,
    badge: "65+ & 79+ targets",
    title: "Advanced Target Batch",
    text: "Intensive coaching + mocks",
    btnText: "Join Today",
    width: "28px",
    height: "28px",
    link: "/auth/register",
  },
  {
    id: 3,
    img: Document,
    hoverImg: GreenDocument,
    badge: "Fast-track students",
    title: "One-On-One Mentoring",
    text: "Personal strategy + direct feedback",
    btnText: "Book Consultation",
    width: "28px",
    height: "28px",
    link: openPopup,
  },
];

  return (
    <React.Fragment>
      <Helmet>
        <title>PTE Online Coaching in Queensland | LA Language Academy</title>
        <meta
          name="description"
          content="Live online PTE coaching in Queensland for Brisbane, Gold Coast, Sunshine Coast, Cairns and regional QLD. Expert trainers, AI mock tests, flexible batches."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.languageacademy.com.au/city/queensland"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="PTE Online Coaching in Queensland | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Live online PTE coaching in Queensland for Brisbane, Gold Coast, Sunshine Coast, Cairns and regional QLD. Expert trainers, AI mock tests, flexible batches."
        />
        <meta
          name="twitter:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content="https://www.languageacademy.com.au/city/queensland"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="PTE Online Coaching in Queensland | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Live online PTE coaching in Queensland for Brisbane, Gold Coast, Sunshine Coast, Cairns and regional QLD. Expert trainers, AI mock tests, flexible batches."
        />
        <meta
          property="og:image"
          content="https://www.languageacademy.com.au/images/logol.png"
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
        <HeroSectionUpdated data={heroData} />

        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>

        <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
          {heroDescriptionSection()}
          <ButtonComp
            link={openPopup}
            btnText={"Book Your Free PTE Assessment"}
            img={"/images/web-new-images/new-dark-arrow.svg"}
          />
        </div>

        <PteConsultation/>

        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText={
              "Ready to secure your required PTE score? Our specialized <span class='plus-sans fw-700 FS18FW400'>PTE Online Coaching in QLD</span> programs are designed for ambitious students across Queensland who demand structured preparation and measurable results."
            }
            btnLink={openPopup}
            btnText="Get Your Free PTE Score Assessment Now"
            btnClassName="mt-4"
            image={Immigration}
            imageClassName="immigration-test-img"
            reverse={true}
            paragraphs={[
              "From Brisbane's academic hubs to professionals in Gold Coast and regional Queensland, our <span class='plus-sans fw-700 FS18FW400'>PTE Online Coaching in Queensland</span> provides expert-led virtual training aligned with the latest exam patterns.",
              "Flexible schedules. AI-powered mock tests. Personalised feedback. Proven results.",
            ]}
          />
        </div>

        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Book a Free PTE Demo Class"}
          btnLink={openPopup}
          img={"/images/web-new-images/new-dark-arrow.svg"}
          skillSubtitle={
            "Experience our teaching style through structured tutorial sessions designed to simplify complex question types and improve scoring techniques."
          }
          noTilt
          padding={"p-80"}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}
          leftSection={false}
          center={"d-flex justify-content-center text-center"}
          noTilt
           btnText2={"Enroll in Our PTE Online Caching Queensland Program"}
        />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle3}
          lifestyleCards={styleCards2}
          skillCardClass={
            styleCards2.length <= 4
              ? `col-md-6 col-lg-${12 / styleCards2.length} d-flex`
              : "col-md-6 col-lg-3 d-flex"
          }
          skillSubtitle={
            "Every section of our PTE Online Course in QLD is designed for measurable results, with structured modules for steady progress."
          }
          noTilt
          padding="pb-0"
        />

        <div className="custom-container py-5">
           <div className="d-flex justify-content-center text-center mb-5">
             {skillAreaTitle4()}
           </div>
           <div className="course-card-data"
                    >
                   {tableData.map((card, index) => (
                   <CourseCard key={card.id} card={card} index={index} />
                   ))}
                   </div>
          <div className="d-flex justify-content-center mt-5">
            <ButtonComp
              link={openPopup}
              btnText={"Get Personalised Score Strategy – Free Consultation"}
              className={"mt-4"}
            />
          </div>
        </div>

        <TestimonialSection
           extraClass={"flex-column flex-lg-row flex-lg-row text-start"}
          extraWidth={"700px"}
          title={`<span class="hero-title FS40FW600 mb-0">Success Stories from <br/><span class="green-text">Queensland Students</span></span>`}
          subtitle={
            "<span style={{maxWidth: '700px'}}>Students across Brisbane, Gold Coast, and regional QLD have achieved significant improvements through structured <span class='plus-sans fw-700 FS18FW400'>PTE Preparation Online in Queensland.</span> </span>"
          }
          showBtn={true}
          sliderList={sliderList}
          btnText={"Join Our Success Community Today"}
          titleClass={"text-start"}
        />
        <TestSection data={testData} bgColor="#080F1E" extraClass={"custom-list-spacing"}/>

        <div style={{ padding: "40px 0 30px 0" }}>
          <CtaBanner
            title="Take the First Step Toward Your"
            highlight="Target Score"
            buttonText="Book Free Consultation"
            // buttonText={"Take Free Mock Test Now"}
            onClick={openPopup}
            rightImage="/images/web-new-images/HomePageImage/CTA-Image.png"
            btnText="Take Free Mock Test Now"
            subTitle={
              "Understand your current performance level before enrolling – identify weak sections, get a performance breakdown, and receive improvement guidance."
            }
          />
        </div>

        <FaqSection questions={faqQuestions} />

        <CTAContactSection
          heading={
            <>
              Design Your{" "}
              <span className="text-success FS40FW600">
                Personalised PTE Preparation Plan
              </span>{" "}
              in Queensland Today
            </>
          }
          subHeading="Every learner's journey is unique. Let us create a customised PTE Online Coaching in Queensland plan aligned with your target score and timeline."
          topRowCards={[
            {
              title: "Phone / WhatsApp",
              icon: IconCall,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  +61 426 230 061
                </p>
              ),
            },
            {
              title: "Email",
              icon: IconEmail,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  info@languageacademy.com.au
                </p>
              ),
            },
            {
              title: "WhatsApp",
              icon: IconChats,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  Quick consultation available
                </p>
              ),
            },
            {
              title: "Walk-in",
              icon: IconLocation,
              content: (
                <p style={{ fontSize: "15px", fontWeight: 700, color: "#fff", margin: 0 }}>
                  Visit any of our <a href="/branches" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>centres</a>
                </p>
              ),
            },
          ]}
          bottomRowCards={[
            {
              title: "Consultation Hours",
              icon: IconClock,
              content: (
                <ul style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Monday–Thursday: 9:00 AM – 5:00 PM
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Saturday: 9:00 AM – 5:00 PM
                  </li>
                </ul>
              ),
            },
            {
              title: "Quick Contact",
              icon: IconInfo,
              content: (
                <ul style={{ margin: 0, padding: "0 0 0 18px", display: "flex", flexDirection: "column", gap: "6px" }}>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Call <a href="tel:+61426230061" style={{ color: "#fff", textDecoration: "underline" }}>+61 426 230 061</a> for immediate assistance
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    WhatsApp <a href="https://wa.me/61426230061" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>+61 426 230 061</a> for quick queries
                  </li>
                  <li className="list-disc" style={{ fontSize: "14px", fontWeight: 600, color: "#fff", lineHeight: 1.5 }}>
                    Email <a href="mailto:info@languageacademy.com.au" style={{ color: "#fff", textDecoration: "underline" }}>info@languageacademy.com.au</a> for detailed inquiries
                  </li>
                </ul>
              ),
            },
          ]}
          cta={{
            label: "Schedule Your Free Consultation – Secure Your Seat Today",
            onClick: openPopup,
          }}
        />

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Queensland;
